import dialogManager from '../components/DialogManager/DialogManager';
import { Select } from '@chakra-ui/react';

import React from 'react';


const HOST = ''
const getBid = ()=>{
  const newSearchParams = new URLSearchParams(window.location.search);
  return newSearchParams.get("bid");
}

class CQAPI {
  init(user, setUser) {
    this.user = user;
    this.setUser = setUser
  }
  async performRequest(method, endpoint, body) {
      const requestOptions = {
        headers: {
          ...body instanceof FormData? {} : {'Content-Type': 'application/json'},
          ...this.user && this.user.token ? { Authorization: `Bearer ${this.user.token}` } : {}
        },
        method,
        ...body? {...body instanceof FormData? {body : body} : {body : JSON.stringify(body)}} : {}
      };
    

      try {
        const response = await fetch(`${HOST}${endpoint}`,requestOptions).then(response => response.json())
        return response;
      } catch (error) {
        return error.response; // Handle the error response
      }
    }
    
    async downloadFile(endpoint){
      const requestOptions = {
        headers: {
          ...this.user && this.user.token ? { Authorization: `Bearer ${this.user.token}` } : {}
        },
        withCredentials: true,
        method: 'GET'
      };
      try {
        const response = await fetch(`${HOST}${endpoint}`,requestOptions)
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
        const blob = await response.blob()
        return window.URL.createObjectURL(blob)
      } catch (error) {
        return error.response; // Handle the error response
      }
    }
    
    
    
    async errorHandler(response, method, endpoint, body) {
      if (response && response.type === 'error') {
        // Handle specific error codes as needed
        if (response.code === 100) {
          this.setUser(null);
          return new Promise((resolve) => {
            const loginResolver = () => {
              resolve(this[method](endpoint, body));
            };
            Auth.onLogin(loginResolver);
          });
        }

        if (response.code === 1100) {
          const shouldRetry = await this.showRetryDialog(response.msg + ' Are you sure you want to continue?');
          if (shouldRetry) {
            return this[method](endpoint + '&confirm=1', body); // Retry the request
          }else{
            return false
          }
        }
        if (response.code === 6100){
          const storedBid = localStorage.getItem('bid')
          const l = storedBid || (await LocationSelectorManager.openLocationSelector().then(x=>x.bid))
          if (getBid() !== l) {
            const newSearchParams = new URLSearchParams(window.location.search);
            newSearchParams.set("bid", l);
            this.navigate(`${window.location.pathname}?${newSearchParams.toString()}`, { replace: true });
          }

          return this[method](endpoint, body);
        }
      }

      return response;
    }
  
  
    async showRetryDialog(message) {
        return new Promise((resolve) => {
          dialogManager.open({
            onAccept: () => {resolve(true); return true},
            onDeny: () => resolve(false),
            acceptText: 'Yes',
            denyText: 'No',
            body: message,
            header: 'Confirmation needed'
          });
        });
      }
      
      getEndpoint(ep){
        const bid = getBid()
        return bid && !ep.includes('bid=')? `${ep}${ep.includes('?')?'&':'?'}bid=${bid}` : `${ep}`; 
      }

      async post(ep, body) {
        body = body || {}
        const endpoint = this.getEndpoint(ep);
        const response = await this.performRequest('post', endpoint, body);
        return this.errorHandler(response, 'post', endpoint, body);
      }

      async get(ep) {
        const endpoint = this.getEndpoint(ep);
        const response = await this.performRequest('get', endpoint);
        return this.errorHandler(response, 'get', endpoint);
      }
      async del(ep, body) {
        const endpoint = this.getEndpoint(ep);
        const response = await this.performRequest('delete', endpoint, body);
        return this.errorHandler(response, 'del', endpoint, body);
      }
      async put(ep, body) {
        const endpoint = this.getEndpoint(ep);
        const response = await this.performRequest('put', endpoint, body);
        return this.errorHandler(response, 'put', endpoint, body);
      }
  }


const cqAPI = new CQAPI()

class AUTH {
  
  init(user, setUser) {
    this.queue = []
    this.user = user;
    this.setUser = setUser
    this.storeUser = (u) => {
      this.setUser(u);
    };
    cqAPI.init(this.user, this.setUser)
  }
  
  onLogin(p){
    this.queue.push(p)
  }
  
  async login(u){
    await Promise.all(this.queue)
  }

  currentAuthenticatedUser() {
    return cqAPI.get('/isloggedin')
  }

  signIn({username,password}) {
    return cqAPI.post('/login',{
      username,
      password
    });
  }

  signOut(user) {
    return cqAPI.get('/logout').then((x)=>{this.storeUser(null)})
  }
}

const Auth = new AUTH()

const loadPatients = async (inputValue) => {
  try {
    const response = await cqAPI.get(
      `/findpatient?query=${inputValue}&role=patient`
    );
    if (response.type === "ok") {
      return response.data
        .filter(
          (x) => x.adapters && x.adapters[x.bid]
        )
        .map((patient) => ({
          label: patient.profile.name,
          value: patient.adapters[patient.bid],
          email: patient.email,
          _id : patient._id
        }));
    }
    return [];
  } catch (error) {
    console.error("Error searching patients:", error);
    return [];
  }
};


class LocationSelectorManager {
  static selectionPromise = null;
  static selectedLocation = null;

  static openLocationSelector = async () => {
    // If there's already a selected location, return it immediately.
    if (LocationSelectorManager.selectedLocation) {
      return Promise.resolve(LocationSelectorManager.selectedLocation);
    }

    // If a selection process is already ongoing, return the existing promise.
    if (LocationSelectorManager.selectionPromise) {
      return LocationSelectorManager.selectionPromise;
    }

    // Create a new promise for the selection process.
    LocationSelectorManager.selectionPromise = new Promise(async (resolve) => {
      const locations = await cqAPI.get('/locations?bid=').then(x => x.data);

      const handleLocationSelect = (event) => {
        // Find and set the selected location based on the event.
        LocationSelectorManager.selectedLocation = locations.find(location => location.bid === event.target.value);
      };

      const body = (
        <Select placeholder="Select location" onChange={handleLocationSelect}>
          {locations.map((location) => (
            <option key={location.bid} value={location.bid}>{location.name}</option>
          ))}
        </Select>
      );

      dialogManager.open({
        body: body,
        header: "Select a Location",
        acceptText: 'Select',
        onAccept: () => {
          // Ensure a location is selected before closing the dialog.
          if (!LocationSelectorManager.selectedLocation) {
            return false;
          }
          resolve(LocationSelectorManager.selectedLocation);
          return true
        },
        isClosable: false,
      });
    });

    return LocationSelectorManager.selectionPromise;
  };
}

const uploadString = async (content, fileType, name, _private=false) => {
  const formData = new FormData();
  const blob = new Blob([content], { type: fileType });
  formData.append("file", blob, name);
  return cqAPI.post(`/upload${_private? '?private=1' : ''}`, formData);
};

export { Auth, cqAPI, getBid, LocationSelectorManager, HOST, loadPatients, uploadString };
